import classNames from 'classnames';
import { ReactNode } from 'react';
import CheckFilled from '@alltrails/shared/icons/CheckFilled';
import { COLOR_BRAND_PLUS_LIGHT } from '@alltrails/shared/denali/tokens';
import * as styles from './PlusUpsell.module.scss';

type FeatureRowProps = {
  text: ReactNode;
  tint: boolean;
  free: boolean;
};

const FeatureRow = ({ text, tint, free }: FeatureRowProps): JSX.Element => (
  <div className={classNames(styles.featureRow, { [styles.featureRowTint]: tint })}>
    <div className={(styles.featureRowCell, styles.featureRowText)}>{text}</div>
    <div className={(styles.featureRowCell, styles.featureRowFree)}>{free && <CheckFilled color={COLOR_BRAND_PLUS_LIGHT} />}</div>
    <div className={(styles.featureRowCell, styles.featureRowPro)}>
      <CheckFilled color={COLOR_BRAND_PLUS_LIGHT} />
    </div>
  </div>
);

export default FeatureRow;
